/**
 * Emoji-knop met keuzemenu.
 *
 * 17-09-2026 (Jordy): in het verzendvenster van de contentkiezer plakte de
 * emoji-knop alleen een vaste 🙂 — er kwam geen menu omhoog, dus was dat de
 * enige emoji die een chatter daar kon gebruiken. Het typvak van het
 * chatvenster had zo'n menu wél. Die keuze staat nu één keer hier, zodat beide
 * plekken dezelfde lijst en hetzelfde gedrag hebben.
 *
 * Klikken voegt de emoji toe aan het veld (verstuurt niets) en sluit het menu.
 * Een klik naast het menu sluit het ook: dat is waar `emojiveil` voor is.
 */
import { useEffect, useState } from 'react'

export const EMOJI: string[] = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '🥰', '😘', '😉', '😜',
  '😏', '🥵', '😈', '👿', '🙈', '💋', '👅', '🍆', '🍑', '💦',
  '❤️', '🔥', '⭐', '✨', '🎉', '👋', '👍', '🙏', '💯', '😅',
  '😭', '🥺', '😳', '😬', '🤔', '😴', '🤤', '😇', '😎', '🤗',
]

export function EmojiKnop({
  onKies,
  title = 'Insert an emoji',
  uitlijnen = 'midden',
}: {
  /** Krijgt de gekozen emoji; de aanroeper plakt hem achter zijn eigen tekst. */
  onKies: (emoji: string) => void
  title?: string
  /** Staat de knop vlak bij een rechterrand (zoals in een venster dat scrollt),
   *  kies dan 'rechts'. Een gecentreerd menu wordt daar afgeknipt. */
  uitlijnen?: 'midden' | 'rechts'
}) {
  const [open, setOpen] = useState(false)
  // 17-09-2026 (HERSTEL-007): Escape sluit het menu. Zonder dat bleef het
  // onzichtbare klikscherm (`emojiveil`) over het hele venster liggen en kon je
  // in de contentkiezer niets meer aanklikken tot je precies naast het menu
  // klikte — in de browsercontrole liep elke volgende klik daarop vast.
  useEffect(() => {
    if (!open) return
    const bijToets = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('keydown', bijToets)
    return () => document.removeEventListener('keydown', bijToets)
  }, [open])
  return (
    <span className="emojiwrap">
      <button type="button" className="iconbtn sm" title={title}
              aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <span aria-hidden="true">🙂</span>
      </button>
      {open ? (
        <>
          <div className="emojiveil" onClick={() => setOpen(false)} />
          <div className={uitlijnen === 'rechts' ? 'emojimenu rechts' : 'emojimenu'}
               role="menu">
            {EMOJI.map((e) => (
              <button key={e} type="button" className="emojibtn" title={e}
                      onClick={() => { onKies(e); setOpen(false) }}>
                {e}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </span>
  )
}
